import { gql } from "@apollo/client";

export const getArticleByPath = gql`
  query GetArticlesByPath($path: String!) {
    pages {
      singleByPath(path: $path, locale: "pt-br") {
        content
        title
        updatedAt
        id
      }
    }
  }
`;
